/*
 * Pantalla de edicion de un criterio IGI (/igi/criterios/editar/:id).
 * Carga el listado (`get_all_criterios`, `data.datos`), busca el criterio por id
 * y permite cambiar nombre, grupo, orden y activo. El boton Guardar envia
 * `update_criterio` (PATCH); al exito (status 200) vuelve al listado.
 */
import React, {useEffect, useState} from "react";
import Button from "../../../../components/button";
import Breadcrumbs from "../../../../components/breadcrumbs";
import Input from "../../../../components/input";
import LoadingSpinner from "../../../../components/loading-spinner";
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory, useParams} from "react-router-dom";
import {
    get_all_criterios,
    update_criterio,
    clear_igi,
    UPDATE_CRITERIO_SUCCESS,
} from "../../../../redux/igi";

/** @module  Pages/Igi/Criterios/Update */

const UpdateCriterio = () => {
    const history = useHistory();
    const {id} = useParams();
    const dispatch = useDispatch();
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const criterios = useSelector((state) => state.igi_module._get_all_criterios);
    const _update_criterio = useSelector((state) => state.igi_module._update_criterio);

    const [form, setForm] = useState({nombre: "", grupo: "", orden: 1, activo: true});
    const [eje, setEje] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        dispatch(clear_igi(UPDATE_CRITERIO_SUCCESS));
        dispatch(get_all_criterios(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (criterios.data && criterios.data.datos) {
            criterios.data.datos.forEach((e) => {
                e.criterios.forEach((c) => {
                    if (c.id === parseInt(id)) {
                        setEje(`${e.codigo} - ${e.nombre}`);
                        setForm({nombre: c.nombre, grupo: c.grupo, orden: c.orden, activo: c.activo});
                    }
                });
            });
        }
    }, [criterios, id]);

    useEffect(() => {
        if (_update_criterio.status === 200) {
            dispatch(clear_igi(UPDATE_CRITERIO_SUCCESS));
            toast.success("El criterio se actualizó correctamente");
            setIsLoading(false);
            history.push("/igi/criterios");
        } else if (_update_criterio.status !== 0) {
            toast.error(_update_criterio.message);
            setIsLoading(false);
        }
    }, [_update_criterio, dispatch, history]);

    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (form.nombre.trim() === "") {
            toast.error("Debe ingresar el nombre del criterio");
            return;
        }
        const orden = parseInt(form.orden);
        if (isNaN(orden) || orden < 1) {
            toast.error("El orden debe ser un número entero mayor que cero");
            return;
        }
        setIsLoading(true);
        dispatch(update_criterio(token, id, {
            nombre: form.nombre,
            grupo: form.grupo,
            orden: orden,
            activo: form.activo,
        }));
    };

    return (
        <div className="app-content content">
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}
            <div className="content-overlay"/>
            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Criterio IGI"
                            items={[{label: "Criterios IGI", link: "/igi/criterios"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Actualizar criterio {eje ? `(${eje})` : ""}</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <Input label="Nombre" id="nombre" name="nombre" onChange={handleChange} value={form.nombre}/>
                                        </div>
                                        <div className="col-md-4">
                                            <Input label="Grupo" id="grupo" name="grupo" onChange={handleChange} value={form.grupo}/>
                                        </div>
                                        <div className="col-md-2">
                                            <Input label="Orden" id="orden" name="orden" type="number" onChange={handleChange} value={form.orden}/>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="d-block">Activo</label>
                                                <input
                                                    type="checkbox"
                                                    name="activo"
                                                    checked={form.activo}
                                                    onChange={(e) => setForm({...form, activo: e.target.checked})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/igi/criterios" className="btn btn-danger m-1">
                                        Cancelar
                                    </Link>
                                    <Button
                                        type="submit"
                                        text={<><i className="bx bx-save"/> Guardar</>}
                                        theme="success"
                                        disabled={isLoading}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateCriterio;
